import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown, UncontrolledTooltip } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle"
import TableContainerV1 from "components/Common/TableContainerV1";
import { useNavigate } from "react-router-dom";
import { deleteFinancierPref, listFinancierPref } from "http/fundLync/financier.helper";
import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";
import { decryptedValue, formatNumberWithCommas, isPermission } from "common/utility";
import * as XLSX from "xlsx";

const TableActionsComponent = (rowData,cbAction) =>{

  const navigate = useNavigate()
  const user = decryptedValue(localStorage.getItem("user"));
    const navigateToEditItem = (id) => {
        const encryptedId = btoa(id.toString());
        navigate(`/${user.roleName}/financer-preference/edit?id=${encodeURIComponent(encryptedId)}`);
      };

      const navigateToViewItem = (id) => {
        const encryptedId = btoa(id.toString());
        navigate(`/${user.roleName}/financer-preference/view?id=${encodeURIComponent(encryptedId)}`);
      };


    
  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">

      <DropdownItem
          onClick={() => { navigateToViewItem(rowData.id) }
          }
        >
          <i className="mdi mdi-eye font-size-16 text-success me-1" id="viewFinItem"></i>
          View
          <UncontrolledTooltip placement="top" target="viewFinItem">
            View
          </UncontrolledTooltip>
        </DropdownItem>

          <DropdownItem
            onClick={() => { navigateToEditItem(rowData.id) }
            }
          >
            <i className="mdi mdi-pencil font-size-16 text-success me-1" id="editFinItem"></i>
            Edit
            <UncontrolledTooltip placement="top" target="editFinItem">
              Edit
            </UncontrolledTooltip>
          </DropdownItem>



        <DropdownItem
          onClick={()=>cbAction({data:rowData,action:'delete'})}
        >
          <i className="mdi mdi-delete font-size-16 text-success me-1" id="deleteFinItem"></i>
          Delete
          <UncontrolledTooltip placement="top" target="deleteFinItem">
           Delete
          </UncontrolledTooltip>
        </DropdownItem>

       

      </DropdownMenu>
    </UncontrolledDropdown>
  )
}


const ListFinPreference = () => {
    document.title = "Financier Preference | FundLync"
    const user = decryptedValue(localStorage.getItem("user"));

    const columns = useMemo(
        () => [
          {
            Header: 'Id',
            accessor: 'id',
            filterable: true,
            Cell: (cellProps) => {
              return cellProps.value || '';
            }
          },
          {
            Header: 'Financier Name',
            accessor: 'financier_id',
            filterable: true,
            Cell: (cellProps) => {
              const rowData = cellProps.row.original;
              return rowData.financier || '';
            }
          },
          {
            Header: 'Min Rating',
            accessor: 'minimumRating',
            filterable: true,
            Cell: (cellProps) => {
              return cellProps.value || '';
              ;
            }
          },
          {
            Header: 'Payout to CI',
            accessor: 'payoutToCi',
            filterable: true,
            Cell: (cellProps) => {
              return cellProps.value;
            }
          },
          {
            Header: 'Integration with CI',
            accessor: 'integrationWithCi',
            filterable: true,
            Cell: (cellProps) => {
              return `${cellProps.value.charAt(0).toUpperCase()}${cellProps.value.slice(1)}`;
            }
          },         
         
          {
            Header: 'Action',
            accessor: '',
            Cell: (cellProps) => {
              const rowData = cellProps.row.original;
              return TableActionsComponent(rowData, handleActionClick,);
            }
          },
    
        ],
        []
      );

    const navigate = useNavigate();
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
    const [finPrefrenceList,setFinPrefrenceList] = useState([])
    const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action', 'entity', 'isSecured', 'interested'] })
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [isDownloadPermission, setIsDownloadPermission] = useState(false)
    
    useEffect(() => {
        fetchFinancierPrefList({})
    }, [])

    const fetchFinancierPrefList = (prop)=>{
        listFinancierPref(prop)
        .then((response) => {
            if (response.status && response.data?.data) {
            setFinPrefrenceList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            if(totalItems>0){
              setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
            }else{
              setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
            }
            }
          })
          .catch((error) => {
    
          });
    }
    useEffect(() => {
      checkPermissions();
    }, []);
    const checkPermissions = async () => {
      const isSDownloadpermission = await isPermission(
        "download_excel_data", 
        "view_permission"
      );
      setIsDownloadPermission(isSDownloadpermission)
    };
    const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        fetchFinancierPrefList({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      }

      const handleSortColumn = (option) => {
        setSortingOptions(option)
        const columnName = option.column;
        setColumnId(columnName)
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder)
        handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)

      }
    
      const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value)
        handlePageChange(1, pageSize, value);
        
      }
    
      const handleClearSearch = () => {
        setSearchValue("")
        handlePageChange(1, pageSize, "")
      }

      const handleCustomerClicks = () => {
         navigate(`/${user.roleName}/financer-preference/add`)
      };

      const handleActionClick =(prop)=>{
        const {data,action} = prop

        if(action=='delete')
        {
          setShowCommonDialog({ isShow: true, data: { type: 'delete',data }, message: 'Are you sure want to delete Preference?' })
        }

      }

      const dialogAction = (action,data) =>{
    
        if(data.type=='delete' && action==1)
        {
            setShowCommonDialog({isShow:false})
            const {data:{id}} = data 
            deletePreferenceCall(id);
        }else {
         
            setShowCommonDialog({isShow:false})
        }
    }

    const deletePreferenceCall = (id)=>{

      deleteFinancierPref({id})
      .then((response) => {
        if (response?.status) {
          setToastInfo({
            message: "Preference deleted successfully",
            showToast: true,
            role: "success",
        })
        handlePageChange(1, pageSize, searchValue)
        } else {
          setToastInfo({
            message: reponse?.message || "Something went wrong.",
            showToast: true,
            role: "error",
        })
        }
    })
    .catch((error) => {
    })
    }

  
    const createAndDownloadExcel = async (fileName, data) => {
      if (data.length === 0) {
        setToastInfo({
          message: "No financier preferences available for download.",
          showToast: true,
          role: "warning",
        });
        return;
      }
    
      const newData = data.map((ele) => {
        
        const negativeIndustries = ele.negativeIndustries.map(ind => ind.industryName).join(", ");
        const preferredIndustries = ele.preferredIndustries.map(ind => ind.industryName).join(", ");
    
       
        let productsArray = [];
        try {
          const products = JSON.parse(ele.products || "[]");
           productsArray= products.map(prod => 
            `Product Type: ${prod.productType}, Product ID: ${prod.productID}, minPriceRange: ${prod.minPriceRange}, maxPriceRange: ${prod.maxPriceRange}, minSanctionAmt: ${prod.minSanctionAmt}, maxSanctionAmt: ${prod.maxSanctionAmt}`
          ).join(",");          
        } catch (error) {
          productsArray = "Invalid product data";
        }
    
     
        const coveredGeography = JSON.parse(ele.coveredGeography || "[]").join(", ");
        const formatNumberWithComma = (num) => {
          if (num === null || num === undefined) {
            return ""; 
          }
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };
        return {
          "Financier Name": ele.financier || "",
          "Min Rating": ele.minimumRating || "",
          "Negative Industries": negativeIndustries || "",
          "Preferred Industries": preferredIndustries || "",
          "Covered Geography": coveredGeography || "",
          "Payout to CI": `${ele.payoutToCi}%` || "",
          "Integration with CI": ele.integrationWithCi ? `${ele.integrationWithCi.charAt(0).toUpperCase()}${ele.integrationWithCi.slice(1)}` : "",
          "Status": ele.status || "",
          "Max Turnover": formatNumberWithComma(ele.maxTurnOver),
          "Min Turnover": formatNumberWithComma(ele.minTurnOver),
          "Products": productsArray|| "",
        };
      });
    

      const ws = XLSX.utils.json_to_sheet(newData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Financier Preferences");
      const buffer = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.download = `${fileName}.xlsx`;
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
      setToastInfo({
        message: "File downloaded successfully.",
        showToast: true,
        role: "success",
      });
    };
    
    const handleDownloadData = () => {
      const fileName = "Financier_Preferences";
      createAndDownloadExcel(fileName, finPrefrenceList);
    };
    

      const buttonSection = (
        <div className="d-flex justify-content-end">
        <div className="text-sm-end">
            <Button
              type="button"
              color="success"
              className="btn-rounded mb-2 me-2"
              onClick={handleCustomerClicks}
            >
              <i className="mdi mdi-plus me-1" />
              {'New Preference'}
            </Button>
        </div>
      <div>
        {isDownloadPermission && (
          <>
            <Button
              id="downloadTooltip"
              type="button"
              color="light"
              className="btn-rounded mb-2 me-2 ms-2 border-success"
              onClick={() => {
                handleDownloadData();
              }}
            >
              <i className="fa fa-download"></i>

            </Button>
            <UncontrolledTooltip placement="top" target="downloadTooltip">
              Download Financier Data
            </UncontrolledTooltip>
          </>
        )}
      </div>
    </div>);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Financier Preference" />
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                <TableContainerV1
                                    columns={columns}
                                    data={finPrefrenceList}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleSearchFilter={handleSearchFilter}
                                    customSection={buttonSection}
                                    sortOptions={sortingOptions}
                                    handleSortColumn={handleSortColumn}
                                    handleClearSearch={handleClearSearch}
                                    className="custom-header-css"
                                />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            {showCommonDialog && 
            <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data}  postitiveBtn={'Submit'} negativeBtn={'Close'}  onCloseFn={dialogAction}></CommonDialog>
             }
                <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    )
}



export default ListFinPreference;